export const WARN_TEXT = {
	delete: {
		page: {
			one: 'editor.quit-dialog.delete.page.changes.by.one',
			many: 'editor.quit-dialog.delete.page.changes.by.many',
		},
		blogpost: {
			one: 'editor.quit-dialog.delete.blogpost.changes.by.one',
			many: 'editor.quit-dialog.delete.blogpost.changes.by.many',
		},
	},
	revert: {
		page: {
			one: 'editor.quit-dialog.revert.page.changes.by.one',
			many: 'editor.quit-dialog.revert.changes.by.many',
		},
		blogpost: {
			one: 'editor.quit-dialog.revert.blogpost.changes.by.one',
			many: 'editor.quit-dialog.revert.changes.by.many',
		},
	},
};

export const SUBMIT_TEXT = {
	delete: {
		page: 'editor.quit-dialog.button.delete.page.exit',
		blogpost: 'editor.quit-dialog.button.delete.blog.exit',
	},
	revert: {
		page: 'editor.quit-dialog.button.revert.page.exit',
		blogpost: 'editor.quit-dialog.button.revert.blog.exit',
	},
};
